// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Stack, Flex } from '@mantine/core';

import { InfoIcon } from 'components/Mantine/InfoIcon';

export const SmallDetailItem = ({
  label,
  tooltip,
  children,
}: {
  label: string;
  tooltip?: string;
  children: ReactNode | null | undefined;
}) => (
  <Stack gap={0} py={4}>
    <Flex fz="sm" c="dimmed" style={{ userSelect: 'none' }} align="center" gap={6}>
      {label}
      <InfoIcon label={tooltip} size={16} />
    </Flex>
    {children ?? '--'}
  </Stack>
);
